import React from 'react';

const Gizlilik: React.FC = () => {
  return (
    <div className="pt-32 pb-24 bg-background">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl font-display text-white mb-8 border-b border-border/20 pb-4">Gizlilik Politikası</h1>
        <div className="flex flex-col gap-6 text-sm text-muted-foreground leading-relaxed">
          <p><strong>Son Güncelleme:</strong> Temmuz 2026</p>
          <p>WE24 Agency olarak, web sitemizi ziyaret eden kullanıcılarımızın gizliliğini korumak bizim için son derece önemlidir. Bu gizlilik politikası, sitemizi ziyaret ettiğinizde verilerinizin nasıl toplandığı ve işlendiği hakkında bilgi vermektedir.</p>
          
          <h3 className="text-lg font-bold text-white mt-4">1. Toplanan Kişisel Veriler</h3>
          <p>İletişim formları veya WhatsApp aracılığıyla paylaştığınız; Ad Soyad, E-posta, Telefon Numarası, Şirket/Marka bilgileri ve proje talebinizle ilgili detaylar, talebinizi yanıtlamak üzere sistemimizde saklanır.</p>

          <h3 className="text-lg font-bold text-white mt-4">2. Verilerin Kullanım Amacı</h3>
          <p>Toplanan kişisel verileriniz, yalnızca aşağıdaki amaçlar doğrultusunda işlenmektedir:</p>
          <ul className="list-disc pl-5 flex flex-col gap-2">
            <li>Sizden gelen proje taleplerini değerlendirmek ve teklif hazırlamak.</li>
            <li>İletişim taleplerinize geri dönüş yapmak.</li>
            <li>Ajansımız bünyesindeki hizmetlerle ilgili teknik güncellemeleri paylaşmak.</li>
          </ul>

          <h3 className="text-lg font-bold text-white mt-4">3. Verilerin Üçüncü Şahıslarla Paylaşımı</h3>
          <p>Kişisel verileriniz hiçbir şekilde üçüncü taraflara satılmaz, kiralanmaz veya ticari amaçla paylaşılmaz. Verileriniz, yasal zorunluluklar haricinde tamamen ajansımız bünyesinde gizli tutulur.</p>

          <h3 className="text-lg font-bold text-white mt-4">4. Güvenlik</h3>
          <p>Verilerinizi yetkisiz erişime, kayba veya çalınmaya karşı korumak için uygun teknik ve idari güvenlik önlemlerini alıyoruz.</p>
        </div>
      </div>
    </div>
  );
};

export default Gizlilik;
